import { CampaignPayload, CampaignsState, ImportData, ImportStep } from './types/types'
import { Campaign } from '../../../api/campaign/types'

export const saveImportStep = (state: CampaignsState, action: { payload: string }) => {
	state.importStep = action.payload
}

export const resetImportFlow = (state: CampaignsState) => {
	state.importStep = ImportStep.CREATE_CAMPAIGN
	state.importData = {} as ImportData
}

export const setSelectedCampaign = (state: CampaignsState, action: { payload: Campaign }) => {
	state.importData.selectedCampaign = action.payload
}

export const setCampaignPayload = (state: CampaignsState, action: { payload: CampaignPayload }) => {
	state.importData.campaignPayload = action.payload
}
